import { ReferenceField } from "@/components/admin/reference-field"
import { Show } from "@/components/admin/show"
import ProfilHeader from "@/components/profile-page/components/profile-header"
import { useResourceContext } from "ra-core"
import * as React from "react"

const ProfileHeader = () => {
  const resource = useResourceContext()

  return (
    <ReferenceField
      source={resource === "users" ? "id" : "user_id"}
      reference="users"
      link={false}
      render={({ error, isPending, referenceRecord }) => {
        if (isPending) {
          return <p>Loading...</p>
        }
        if (error) {
          return <p className="error">{error.message}</p>
        }
        return (
          <ProfilHeader
            first_name={referenceRecord?.first_name}
            last_name={referenceRecord?.last_name}
            email={referenceRecord?.email}
            avatar={referenceRecord?.avatar.src}
          />
        )
      }}
    />
  )
}

export const UserRelatedShow: React.FC<{ children: React.ReactNode }> =
  function ({ children }) {
    return (
      <Show title={null}>
        <ProfileHeader />
        {children}
      </Show>
    )
  }
